import { ProductUpsellColourPresets, ProductUpsellLayoutPresets } from '../types/upsellTypes';

export const useProductUpsellColourPresets = (): ProductUpsellColourPresets => {
  return {
    green: {
      style: {
        pill: {
          pillTextColor: `rgba(0, 0, 0, 1)`,
          pillBackgroundColor: `rgba(246, 255, 0, 1)`,
        },
        mainBody: {
          backgroundColor: `rgba(60, 211, 87, 1)`,
          mainTextColor: `rgba(255, 255, 255, 1)`,
          highlightTextColor: `rgba(0, 0, 0, 1)`,
          accentTextColor: `rgba(99, 99, 102, 1)`,
        },
        button: {
          buttonTextColor: `rgba(0, 0, 0, 1)`,
          buttonBackgroundColor: `rgba(255, 255, 255, 1)`,
        },
      },
    },
    yellow: {
      style: {
        pill: {
          pillTextColor: 'rgba(255, 255, 255, 1)',
          pillBackgroundColor: 'rgba(255, 59, 48, 1)',
        },
        mainBody: {
          backgroundColor: 'rgba(246, 255, 0, 1)',
          mainTextColor: 'rgba(68, 0, 153, 1)',
          highlightTextColor: 'rgba(0, 0, 0, 1)',
        },
        button: {
          buttonTextColor: `rgba(255, 255, 255, 1)`,
          buttonBackgroundColor: `rgba(0, 0, 0, 1)`,
        },
      },
    },
    pink: {
      style: {
        pill: {
          pillTextColor: 'rgba(0, 0, 0, 1)',
          pillBackgroundColor: 'rgba(246, 255, 0, 1)',
        },
        mainBody: {
          backgroundColor: 'rgba(255, 0, 132, 1)',
          mainTextColor: 'rgba(255, 255, 255, 1)',
          highlightTextColor: 'rgba(246, 255, 0, 1)',
        },
        button: {
          buttonTextColor: 'rgba(0, 0, 0, 1)',
          buttonBackgroundColor: 'rgba(255, 255, 255, 1)',
        },
      },
    },
    red: {
      style: {
        pill: {
          pillTextColor: 'rgba(0, 0, 0, 1)',
          pillBackgroundColor: 'rgba(246, 255, 0, 1)',
        },
        mainBody: {
          backgroundColor: 'rgba(250, 70, 69, 1)',
          mainTextColor: 'rgba(255, 255, 255, 1)',
          highlightTextColor: 'rgba(246, 255, 0, 1)',
        },
        button: {
          buttonTextColor: 'rgba(0, 0, 0, 1)',
          buttonBackgroundColor: 'rgba(255, 255, 255, 1)',
        },
      },
    },
    orange: {
      style: {
        pill: {
          pillTextColor: 'rgba(255, 255, 255, 1)',
          pillBackgroundColor: 'rgba(255, 0, 0, 1)',
        },
        mainBody: {
          backgroundColor: 'rgba(255, 191, 0, 1)',
          mainTextColor: 'rgba(255, 255, 255, 1)',
          highlightTextColor: 'rgba(255, 0, 0, 1)',
        },
        button: {
          buttonTextColor: 'rgba(255, 255, 255, 1)',
          buttonBackgroundColor: 'rgba(0, 0, 0, 1)',
        },
      },
    },
    blue: {
      style: {
        pill: {
          pillTextColor: `rgba(0, 0, 0, 1)`,
          pillBackgroundColor: `rgba(246, 255, 0, 1)`,
        },
        mainBody: {
          backgroundColor: 'rgba(109, 158, 235, 1)',
          mainTextColor: 'rgba(255, 255, 255, 1)',
          highlightTextColor: 'rgba(246, 255, 0, 1)',
        },
        button: {
          buttonTextColor: 'rgba(0, 0, 0, 1)',
          buttonBackgroundColor: 'rgba(255, 255, 255, 1)',
        },
      },
    },
  };
};

export const useProductUpsellLayoutPresets = (): ProductUpsellLayoutPresets => {
  return {
    imageOverflow: {
      style: {
        mainBody: {
          containerStyle: {
            mobile: { overflow: 'visible', gridTemplateColumns: '60% 50%' },
            desktop: { overflow: 'visible', gridTemplateColumns: '60% 50%' },
          },
        },
        media: {
          mediaStyle: {
            mobile: {
              overflow: 'visible' as const,
              position: 'absolute' as const,
              bottom: '.25rem',
              right: '2.25rem',
              width: '95%',
            },
            desktop: {
              overflow: 'visible' as const,
              position: 'absolute' as const,
              bottom: '.25rem',
              right: '2.25rem',
              width: '95%',
            },
          },
        },
      },
    },
    imageBottom: {
      style: {
        media: {
          mediaContainer: {
            justifyContent: 'flex-end' as const,
            flexDirection: 'column' as const,
            height: '100%',
          },
        },
      },
    },
    imageLeft: {
      style: {
        media: {
          mediaStyle: {
            paddingRight: '0.5rem' as const,
          },
        },
      },
    },
    imageRight: {
      style: {
        media: {
          mediaStyle: {
            right: '0rem',
          },
        },
      },
    },
    slightRight: {
      style: {
        media: {
          mediaStyle: {
            right: '1rem',
          },
        },
      },
    },
    slightRightDrop: {
      style: {
        media: {
          mediaStyle: {
            right: '1rem',
            bottom: '-0.75rem',
          },
        },
      },
    },
  };
};
